<template>
  <div class="card">
    <div class="card-header" style="display: flex;flex-direction: row;">
      <div style="margin-right: 50px;"><code class="text-center text-warning"><h2 class="card-title">Detail information for unpaid activities</h2></code></div>
    </div>
    <div class="card-body">
      <div class="table-responsive" style="overflow: auto">
        <table class="table tablesorter">
          <thead class=" text-primary">
          <tr>
            <th>
              <code class="text-center text-warning" style="font-size: 16px">Full name</code>
            </th>
            <th class="text-center">
              <span class="text-center text-warning" style="font-size: 16px">Total days</span>
            </th>
            <th class="text-center">
              <span class="text-center text-warning" style="font-size: 16px">Total hours</span>
            </th>
            <th class="text-center">
              <span class="text-center text-warning" style="font-size: 16px">Total payment</span>
            </th>
            <th class="text-center">
              <code class="text-center text-warning" style="font-size: 16px">Paid</code>
            </th>
          </tr>
          </thead>
          <tbody id="payments">
            <tr v-for="(item, index) in payments" v-bind:id="'employee_'+item.employee_id" :key="index">
            <td>
              {{index.split('_').join(' ')}}
            </td>
            <td class="text-center">
              {{item.days}}
            </td>
            <td class="text-center">
              {{item.hours}}
            </td>
            <td class="text-center">
              <p class="text-success" style="font-size: 20px;">{{formatter.format(item.money)}}</p>
            </td>
            <td class="text-center">
              <base-button class="clock-button" size="lg" simple type="danger" @click="payCompensation(item.employee_id)">Pay</base-button>
            </td>
          </tr>
            <tr>
              <td colspan="2"></td>
              <td class="text-center">
                <span style="font-size: 20px;" class="text-warning">TOTAL:</span>
              </td>
              <td class="text-center">
                <p class="text-success" style="font-size: 20px;" >{{formatter.format(totalCount(payments))}}</p>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {isMobile} from "../../plugins/axios";
  import {formatter} from "../../plugins/axios";

  export default {
    props: ['payments'],
    name: "to-pay-table",
    data(){
      return{
        formatter:formatter,
      }
    },
    methods:{
      payCompensation(employee_id){
        this.$emit('to-payroll', employee_id);
      },
      totalCount(payments){
        let total = 0;
        for (let index in payments){
          total += payments[index].money;
        }
        return total;
      },
    },
  }
</script>

<style scoped>

</style>
